import useComputed from '@/hooks/use-computed'
import useSchemaProperties from '@/hooks/use-schema-properties/index'
import api from '@/services/api/dataElementDetails.js'
import API_ENROLMENT from '@/services/api/enrolment.js'
import { immerable } from "immer"
import { useState } from 'react'
class DataElement {

	[immerable] = true

	constructor(params) {
		this.dataElement = params.dataElement
		this.modified = params.modified
		this.useCase = params.useCase
		this.system = params.system
		this.requiredFields = params.requiredFields
		this.optionalFields = params.optionalFields
		this.attachmentFields = params.attachmentFields
		this.type = params.type
		this.participants = params.participants
	}
}

const useDataElements = (_dataElementId) => {

	const [items, setItems] = useComputed([])

	const { getRequiredFields, getOptionalFields, getAttachments } = useSchemaProperties();

	const [metaDataElementDetail, setMetaDataElementDetail] = useState(null)

	const [currentItem, setCurrentItem] = useState(null)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState()

	async function fetch(parameter) {

		setLoading(true)

		const params = parameter ? parameter : "";

		const [errorResponse, dataResponse] = await api.index({
			params
		})

		setLoading(false)

		if (errorResponse) {
			return setError(errorResponse)
		}

		const { meta } = dataResponse

		if (!Array.isArray(dataResponse)) {
			return setError('Data Elements Details is not an array')
		}

		const serializedData = dataResponse.map(entry => serialize(entry))
		const newItems = serializedData.map(data => new DataElement(data))

		setMetaDataElementDetail(meta)
		return setItems(newItems)
	}

	async function find(parameter) {

		setLoading(true)

		const params = parameter ? parameter : "";

		const [errorResponse, dataResponse] = await api.index({
			params
		})

		setLoading(false)

		if (errorResponse) {
			return setError(errorResponse)
		}

		if (!Array.isArray(dataResponse)) {
			return setError('Data Elements Details is not an array')
		}

		const serializedData = dataResponse.map(entry => serialize(entry))
		return serializedData.map(data => new DataElement(data))
	}

	async function fetchDataElementsDetail(parameter) {

		setLoading(true)

		const params = parameter ? parameter : "";

		const [errorResponse, dataResponse] = await api.getDataElementDetails({
			params
		})

		setLoading(false)

		if (errorResponse) {
			return setError(errorResponse)
		}

		if (!Array.isArray(dataResponse)) {
			return setError('Data Elements Details is not an array')
		}

		const serializedData = dataResponse.map(entry => serialize(entry))
		const newItems = serializedData.map(data => new DataElement(data))

		return newItems[0]
	}

	async function fetchEnrolmentPrincipals(enrolmentId) {
		setLoading(true)
		const [errorResponse, dataResponse] = await API_ENROLMENT.getEnrolmentPrincipals(enrolmentId)
		setLoading(false)

		if (errorResponse) {
			return setError(errorResponse)
		}

		if (!Array.isArray(dataResponse)) {
			return setError('Data Elements Details is not an array')
		}

		return dataResponse
	}

	function serialize(entry) {

		const requiredFields = getRequiredFields(entry.dataElement?.dataElementSchema)
		const optionalFields = getOptionalFields(entry.dataElement?.dataElementSchema)
		const attachmentFields = getAttachments(entry.dataElement?.dataElementSchema)
		return {
			dataElement: entry.dataElement,
			modified: entry.modifiedAt,
			useCase: entry.useCase,
			system: entry.systems,
			requiredFields: requiredFields,
			optionalFields: optionalFields,
			attachmentFields: attachmentFields,
			type: entry.type,
			participants: entry.participants
		}
	}

	function view(id) {
		const newCurrentItem = items.find(item => item.id === id)
		setCurrentItem(newCurrentItem)
	}

	return {
		error,
		fetch,
		items,
		currentItem,
		setCurrentItem,
		loading,
		setItems,
		view,
		find,
		metaDataElementDetail,
		fetchDataElementsDetail,
		fetchEnrolmentPrincipals,
	}

}

export default useDataElements
